
export const getErrorMessage = (t: any, errorMessage: string): string => {
    const errorMap: Record<string, string> = {
        'Wrong username or password': t('login-password'),
    };

    return errorMap[errorMessage] || t('unknown-error');
};